import { useCallback, useMemo } from 'react';
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';

export function useRouter() {
  const params = useParams();
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();
  const location = useLocation();

  const query = useMemo(() => {
    return {
      ...params,
      ...Object.fromEntries(searchParams),
    };
  }, [params, searchParams]);

  const back = useCallback(() => navigate(-1), [navigate]);

  const push = useCallback((url: string) => navigate(url), [navigate]);

  const replace = useCallback(
    (url: string) => navigate(url, { replace: true }),
    [navigate],
  );

  return {
    query,
    back,
    push,
    replace,
    asPath: location.pathname,
    /**
     * The raw query string, leading `?` included (empty when there is none).
     * `query` flattens route params and search params together, which loses
     * whether a param was in the URL at all — callers that need to compare the
     * current URL against one they are about to navigate to need this.
     */
    search: location.search,
  };
}
